import { default as React, useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Page from '../layout/Page'
import { Button, Paper } from '@mui/material'
import { default as bus } from '../utils/EventBus'
import ListViewCommandBar from '../commandBar/ListViewCommandBar.js'
import ListExtendedAttributes from './ListExtendedAttributes.js'

export default function ManageExtendedAttributesPage (props = {}) {
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const [listRefreshKey, setListRefreshKey] = useState(new Date().toISOString())
  const startLoading = useCallback(() => {
    setIsLoading(true)
  }, [])

  const stopLoading = useCallback(() => {
    setIsLoading(false)
  }, [])

  const addRecord = useCallback(() => {
    console.log('add record')
    bus.emit('add-extended-attribute')
  }, [])

  const breadcrumb = (
    <span>
      <Button
        variant="text"
        onClick={() => navigate('/app/admin')}
        sx={{ minWidth: 0, p: 0, textTransform: 'none' }}
      >
        Application Administration
      </Button>
      {' > '}Manage Extended Attributes
    </span>
  )

  const [showFilters, setShowFilters] = useState(false)
  const toggleFilters = useCallback(() => {
    setShowFilters(prev => !prev)
  }, [])

  const refreshList = useCallback(() => {
    setListRefreshKey(new Date().toISOString())
  }, [])

  return (
    <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading} 
    commandBar={
      <ListViewCommandBar 
        showFilters={true}
        toggleFilters={toggleFilters} 
        addRecord={addRecord} 
        showAdd={true}              
      />
    }>
      <Paper sx={{margin: '0 auto 1em auto' }}>
          <ListExtendedAttributes
            key={listRefreshKey}
            showFilters={showFilters}
            startLoading={startLoading}
            stopLoading={stopLoading}
            searchFilter={{isActive: false}}
            refresh={refreshList}
          />
      </Paper>
  </Page>
  )
}